module.exports = __webpack_public_path__ + "media/images/misc/border-h-fb3650746508ab92db81cadfffb26ba4bb3056b6c04331f844e8737e656babaa.gif";